import * as React from 'react';
import { observer } from 'mobx-react';
import './login.scss';
import { makeStyles } from '@material-ui/core/styles';
import { Input, InputLabel, InputAdornment, FormControl, TextField, Button } from '@material-ui/core';
import { setCookie, isWechar } from '../../utils/utils.ts';
import AccountCircle from '@material-ui/icons/AccountCircle';
import { login } from '@/api/apiList/admini.js';
const { useState, useEffect, Fragment, memo } = React;
const useStyles = makeStyles(theme => ({
    margin: {
        margin: theme.spacing(1)
    }
}));
export default memo(props => {
    const classes = useStyles();
    const [name, setName] = useState('');
    const [password, setPassword] = useState('');
    const handleChange = event => {
        setName(event.target.value);
    };
    const handlePassChange = event => {
        setPassword(event.target.value);
    };
    const onSub = async () => {
        const res = await login({
            userName: name,
            password: password
        });
        if (res.status == 200) {
            setCookie('userName', name, 1);
            setCookie('roleType', res.result.roleType, 1);
            setCookie('token', res.result.token, 1);
            window.location.href = `//${window.location.host}`;
        }
    };

    return (
        <div className='LoginWrap'>
            <div className='login'>
                <div className='box-login'>
                    <div className='login-title'>数据平台登录</div>
                    <FormControl className={classes.margin}>
                        <InputLabel htmlFor='component-simple'>域账号</InputLabel>
                        <Input id='component-simple' value={name} onChange={handleChange} />
                    </FormControl>
                    <FormControl className={classes.margin}>
                        <InputLabel htmlFor='component-password'>密码</InputLabel>
                        <Input id='component-password' type='password' value={password} onChange={handlePassChange} />
                    </FormControl>
                    <div style={{ marginTop: '20px' }}>
                        <Button className='btn-wrap' variant='contained' color='primary' onClick={onSub}>
                            登陆
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
});
